import { render, staticRenderFns } from "./tagInputInEdit.vue?vue&type=template&id=05b442f6&scoped=true"
import script from "./tagInputInEdit.vue?vue&type=script&lang=js"
export * from "./tagInputInEdit.vue?vue&type=script&lang=js"
import style0 from "./tagInputInEdit.vue?vue&type=style&index=0&id=05b442f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b442f6",
  null
  
)

export default component.exports